import { Navigate, type RouteObject } from "react-router";

import { activityRouteChildren } from "@/pages/import/ActivityPage";
import { datalakesRouteChildren } from "@/pages/import/DatalakesPage";
import { datasetsRouteChildren } from "@/pages/import/DatasetsPage";
import { destinationsRouteChildren } from "@/pages/import/DestinationsPage";
import { overviewRouteChildren } from "@/pages/import/OverviewPage";
import { providersRouteChildren } from "@/pages/import/ProvidersPage";
import { sourcesRouteChildren } from "@/pages/import/SourcesPage";
import { streamsRouteChildren } from "@/pages/import/StreamsPage";

export const importRoutes: RouteObject = {
  path: "import",
  handle: {
    breadcrumb: () => ({ label: "Import" }),
  },
  children: [
    {
      index: true,
      element: <Navigate to="/import/overview" replace />,
    },
    overviewRouteChildren,
    activityRouteChildren,
    datalakesRouteChildren,
    datasetsRouteChildren,
    providersRouteChildren,
    destinationsRouteChildren,
    sourcesRouteChildren,
    streamsRouteChildren,
  ],
};
